import { forEachPositionTriggerByGuid } from './forEachPositionTriggerByGuid';
import { getCommentIconsByTriggerElement } from './getCommentIconsByTriggerElement';

export const removeNoCommentsClassForPositionGuid = (positionGuid: string): void => {
    forEachPositionTriggerByGuid(positionGuid, (triggerElement) => {
        const { commentActionIcon, positionCommentIcon } =
            getCommentIconsByTriggerElement(triggerElement);

        commentActionIcon?.classList.remove('has-no-comments');
        positionCommentIcon?.classList.remove('has-no-comments');
    });
};
